import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CommonServices } from 'src/app/Common/CommonServices';
import { PaymentClient, PlatformChargesClient, RefundPaymentInfo, UsaePayQueryResponse, User, WebinarClient, WebinarRoomDTO, WebinarRoomOwnerDTO, WebinarSettlementDetail, WebinarSettlementDetailsGetDTO } from 'src/app/Services/WOWApi.Service';
import { CommonService } from 'src/app/Services/common.service';

@Component({
    selector: 'app-host-dashboard',
    templateUrl: './host-dashboard.component.html',
    styleUrls: ['./host-dashboard.component.css'],
    standalone: false
})
export class HostDashboardComponent implements OnInit {
  createWebinar  = true;
  webinarQueue:boolean = false;
  configuration:boolean = false;
  stats:boolean = false;
  webinarHistorical:boolean = false;
  shipments:boolean = false;
  outOfOffice:boolean = false;
  webinarId:number = 0;
  selectedTab:number = 0;
  isLoading: any = {};
  refundPaymentInfo: RefundPaymentInfo[];
  orderItemsParsedJson: any[] = [];
  roomsList: WebinarRoomOwnerDTO[] = [];
  currentRefundStatus: UsaePayQueryResponse[] = [];
  userDetails: User;
  actionMessage: string = '';
  showAccountDetails = false;
  showSettledWebinars = false;
  showSettlementDetails = false;
  settledWebinars: WebinarSettlementDetail[];
  alreadySettledAmount = 0.00;
  pendingForSettlement = 0.00;
  readyForSettlement = 0.00;
  details: WebinarSettlementDetailsGetDTO[] = [];
  isMobileView = false;
  subscription: Subscription;
  selectedOptionToViewForMobile: string = '';
  refundStatusRoomIdControl = new UntypedFormControl('');
  paymentRoomIdControl = new UntypedFormControl('');
  constructor(
    private paymentClient: PaymentClient,
    private commonServices: CommonServices,
    private webinarClient: WebinarClient,
    private platformChargesClient: PlatformChargesClient,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.userDetails = JSON.parse(localStorage.getItem("UserInfo"));
    this.getWebinarRoomsList(this.userDetails.id);
    // this.getLatestRefundStatusByTransactionId('3173164343');
  }

  EditWebinar(webinarId) {
    this.webinarId = webinarId;
    if (this.isMobileView) {
      this.selectedOptionToViewForMobile = 'NewWebinar';
    } else {
      this.tabChange(0);
    }
    this.selectedTab = 0;
  }

  tabChange(index: number){
    this.createWebinar  = false;
    this.webinarQueue  = false;
    this.configuration  = false;
    this.stats  = false;
    this.webinarHistorical  = false;
    this.shipments  = false;
    this.outOfOffice  = false;
    switch(index)
    {
      case 0 :
        this.createWebinar = true;
        break;
      case 1 :
        this.webinarQueue = true;
        break;
      case 2 :
        this.configuration = true;
        break;
      case 3 :
        this.stats = true;
        break;
      case 4 :
          this.shipments = true;        
        break;
      case 5 :
          this.webinarHistorical = true;
        break;
      case 6 :
          this.outOfOffice = true;
          break;
      case 7: {
        const roomId = this.refundStatusRoomIdControl.value || this.roomsList[0]?.webinarRoomId;
        if (roomId) {
          this.getRefundStatusByRoomId(roomId);
        }
        break;
      }
      case 8:
        this.GetWebinarSettlementDetailsRoomId(this.roomsList[0].webinarRoomId);
        break;
    }  
  }

  onChangeHostMobielViewOption(option: string) {
    this.webinarId = 0;
    if (option === 'Payments') {
      this.GetWebinarSettlementDetailsRoomId(this.roomsList[0].webinarRoomId);
    }
  }

  getWebinarRoomsList(userId: number) {
    this.isLoading.rooms = true;
    this.webinarClient.getWebinarRoomsByUser(userId).subscribe(res => {
      this.roomsList = res;
      if (res.length > 0) {
        this.refundStatusRoomIdControl.setValue(res[0].webinarRoomId);
        this.paymentRoomIdControl.setValue(res[0].webinarRoomId);
      }
      this.isLoading.rooms = false;
    }, error => {
      console.error(error);
      this.isLoading.rooms = false;
    });
  }

  getRefundStatusByRoomId(roomId: number) {
    this.isLoading.status = true;
    this.paymentClient.getRefundPaymentInfoForHostPortal(roomId).subscribe(res => {
      this.refundPaymentInfo = res;
      const parsed = [];
      this.refundPaymentInfo.map(x => {
        parsed.push(JSON.parse(x.orderItemsJson))
      });
      this.orderItemsParsedJson = parsed;
      this.currentRefundStatus = [];
      this.isLoading.status = false;
    }, error => {
      this.isLoading.status = false;
      this.commonServices.showMessage('X', `${error.error}`, 5);
    });
  }

  getLatestRefundStatusByTransactionId(transactionId: string, i: number) {
    this.isLoading.latestStatus = true;
    this.paymentClient.getTransactionDetailsFromNmiGateway(transactionId).subscribe(res => {
      const next = this.currentRefundStatus.slice();
      next[i] = res;
      this.currentRefundStatus = next;
      this.isLoading.latestStatus = false;
    }, error => {
      this.commonServices.showMessage('X', `${error.error}`, 5);
      this.isLoading.latestStatus = false;
    })
  }

  onPaymentAction(type: string) {
    switch(type) {
      case 'paymentDetails':
        this.showAccountDetails = true;
        this.showSettledWebinars = false;
        this.showSettlementDetails = false;
        break;
      case 'alreadySettled':
        this.getAlreadySettledWebiinarsByRoomOwnerId(this.roomsList[0].webinarRoomId);
        this.showAccountDetails = false;
        this.showSettledWebinars = true;
        this.showSettlementDetails = false;
        break;
      case 'settlementDetails':
        this.showAccountDetails = false;
        this.showSettledWebinars = false;
        this.showSettlementDetails = true;
        break;
      // case 'withdraw':
      //   this.showAccountDetails = false;
      //   this.showSettledWebinars = false;
      //   this.actionMessage = `Total $95 out of $100 (5% platform charges)  will be transferred to the account 
      //   'BANK NAME : CITI, ACC NO. : 12345678923323', please confirm to transfer.`;
      //   break;
    }
  }

  GetPaymentDetails(roomId: number) {
    this.getAlreadySettledWebiinarsByRoomOwnerId(roomId);
  }

  getAlreadySettledWebiinarsByRoomOwnerId(roomId: number) {
    this.platformChargesClient.getAllWebinarAccountSettled(roomId).subscribe(res => {
      this.settledWebinars = res;
    }, error => {
      this.commonServices.showMessage('error', error, 5);
    })
  }

  GetWebinarSettlementDetailsRoomId(roomId: number) {
    this.readyForSettlement = 0;
    this.pendingForSettlement = 0;
    this.alreadySettledAmount  = 0;
    this.webinarClient.getRoomWiseAccountSettlementDetails(roomId).subscribe(res => {
      this.details = res;
      this.details.map(x => {
        this.readyForSettlement += x.readyForSettlement;
        this.pendingForSettlement += x.pendingForSettlement;
        this.alreadySettledAmount += x.settledAmount;
      })
    }, error => {
      this.commonServices.showMessage('error', error, 5);
    })
  }

  onOpenSettlementProof(base64Image: string) {
    const image = 'data:image/png;base64,' + base64Image;
    const newWindow = window.open('', '_blank');

    if (newWindow) {
      newWindow.document.write(`
        <html>
          <head>
            <title>Image Viewer</title>
            <style>
              body {
                margin: 0;
                display: flex;
                justify-content: center;
                align-items: center; 
                height: 100vh;
                background-color: #f0f0f0;
              }
              img {
                max-width: 100%;
                max-height: 100%;
              }
            </style>
          </head>
          <body>
            <img src="${image}" />
          </body>
        </html>
      `);
    } else {
      alert('Popup blocked! Please allow popups for this website.');
    }
  }

  formatCurrency(amount: number): string {
    const value = Number(amount);
    if (!isFinite(value)) {
      return '0.00';
    }
    return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  refundStatusLabel(res?: UsaePayQueryResponse, refund?: RefundPaymentInfo): string {
    const live = res?.status || res?.result;
    if (live) {
      return live;
    }
    return refund?.paymentStatusMaster?.paymentStatus || 'Status unavailable';
  }

  orderName(order: any): string {
    return order?.Webinar?.Name || order?.webinar?.name || order?.WebinarName || order?.name || 'Prize item';
  }

  orderSeat(order: any): string | number {
    return order?.SeatId ?? order?.seatId ?? '—';
  }

  orderAmount(order: any): number {
    return Number(order?.Amount ?? order?.amount ?? 0);
  }

  refundStatusTone(status?: string): 'ok' | 'wait' | 'bad' {
    const value = (status || '').toLowerCase();
    if (value.includes('approve') || value.includes('success') || value.includes('settled') || value.includes('complete')) {
      return 'ok';
    }
    if (value.includes('void') || value.includes('fail') || value.includes('error') || value.includes('decline') || value.includes('reject') || value.includes('cancel')) {
      return 'bad';
    }
    return 'wait';
  }

 
}
